export default __webpack_public_path__ + "static/media/Darsh.7713c61c.png";